export class ServiceAddress {
   address:string;
   city:string;
   createdBy:string;
   id: number;
   isActive: true;
   nursePractitionerId:string;
   state:string;
   zip:string;
   memberId:string;
   stateId: string;

}